module.exports = __webpack_public_path__ + "img/i_security.86902bde.svg";